<template>
  <section class="v-loading">
    <div class="spinner" :style="spinnerStyleObj" ref="spinner">
      <div class="quarter-circle" :style="circleStyleObj"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: "v-loading",
  props: {
    width: {
      type: Number,
      default: 60,
    },
    color: {
      type: String,
      default: "#000",
    },
    center: {
      type: Boolean,
      default: false,
    },
    verticalCenter: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      spinnerStyleObj: {},
      circleStyleObj: {},
    };
  },
  created() {
    this.spinnerStyleObj = {
      width: `${this.width}px`,
      height: `${this.width}px`,
    };

    this.circleStyleObj = {
      width: `${this.width / 2}px`,
      height: `${this.width / 2}px`,
      "border-top-left-radius": `${this.width}px`,
      color: this.color,
    };
  },
  mounted() {
    if (this.center) {
      $(this.$refs.spinner).css("margin", "0 auto");
    }
    if (this.verticalCenter) {
      this.$refs.spinner.classList.add("vertical-center");
    }
  },
};
</script>

<style scoped lang="scss">
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
.v-loading {
  position: fixed;
  position: relative;
  z-index: 9999999;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 100px);

  .spinner {
    margin: 0 !important;
    .quarter-circle {
      border-top-left-radius: 60px;
      border: 1px solid currentColor;
      border-bottom: 0;
      border-right: 0;
      animation: 1s linear infinite spin;
      transform-origin: 100% 100%;
      transition: opacity 0.5s cubic-bezier(0.5, 0, 0.2, 1);
      opacity: 1;
    }

    &.vertical-center {
      position: fixed;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
